import styled from "styled-components";

export const TermText = styled.div`
  padding: 16px;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.2rem;
  line-height: 160%;

  b {
    color: ${(props) => props.theme.colors.black100};
  }

  img {
    width: 100%;
    object-fit: contain;
    object-position: center;
  }

  .img_example {
    b {
      display: inline-block;
      width: 100%;
      color: ${(props) => props.theme.colors.primary100};
      font-size: 1.4rem;
      text-align: center;
    }
  }
`;
